// extracted by mini-css-extract-plugin
export default {"container":"PreQuestionnaire_container__6sn6b","container_center":"PreQuestionnaire_container_center__X61aD"};